<template lang="html">
<div class="pgInner prdEdit">

    <div class="headBar">
        <span v-if="sort==2">新建产品</span>
        <span v-if="sort==3">新建服务</span>
    </div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="true">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">
                        <span class="dot">*</span>
                        <span>分类</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="productServiceCategoryId">
                               <dic-select v-if="sort==2" code="cpfl"
                                    :selectId="params.productServiceCategoryId"
                                    paramsKey="productServiceCategory"
                                    @selectChange="selectChange"
                                    plaText="分类" />

                               <dic-select v-if="sort==3" code="fwfl"
                                    :selectId="params.productServiceCategoryId"
                                    paramsKey="productServiceCategory"
                                    @selectChange="selectChange"
                                    plaText="分类" />
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>标题</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span v-if="sort==2">产品介绍</span>
                         <span v-if="sort==3">服务介绍</span>
                     </div>
                     <div class="bContent">
                         <textEditor ref="textEditor" :inContent="params.content" @onchange="contentChange" />
                         <!-- <editor id="editor_id" height="500px" width="100%" :content="params.content"
                         @on-content-change="contentChange"
                         pluginsPath="/static/kindeditor/plugins/"
                         :loadStyleMode="false"></editor> -->
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">所属企业</div>
                     <div class="bContent">
                             <el-select
                                 class="inpText"
                                 v-model="params.publishCompanyId"
                                 filterable
                                 remote
                                 clearable
                                 reserve-keyword
                                 placeholder="输入企业名称"
                                 :remote-method="eprSeek"
                                 @change="eprSelect">
                                 <el-option
                                   v-for="item in selectArr"
                                   :key="item.id"
                                   :label="item.companyName"
                                   :value="item.id">
                                 </el-option>
                             </el-select>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>联系人</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="contactPerson">
                               <el-input size="medium" class="inpText" v-model="params.contactPerson" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>联系电话</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="contactPhone">
                               <el-input size="medium" class="inpText" v-model="params.contactPhone" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>头部图</span>
                     </div>
                     <div class="bContent">
                           <imgs-upload :files="params.coverImage" @fileChange="imgChange" tips="（375*200推荐）" />
                     </div>
                 </div>

                 <div class="text-block tag-block clearfix">
                     <div class="bName">标签</div>
                     <div class="bContent">
                          <tag-select :selectTags="params.tagNames" paramsKey="tagNames" @selectChange="tagChange" />
                     </div>
                 </div>

                 <div class="text-block radio-block clearfix">
                     <div class="bName">审核</div>
                     <div class="bContent">
                       <el-radio-group v-model="params.status">
                          <el-radio :label="3">通过</el-radio>
                          <el-radio :label="4">不通过</el-radio>
                       </el-radio-group>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave" type="primary" size="small">保存</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { msgCreate,msgPredat } from "@/api/message/message";
import { getEnterpriseList } from "@/api/attes/attestation";
import { dicSeek } from "@/api/pgMent/dictMent";

let isPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('联系电话不能为空'));
    }else{
        let pattern = /^1[3|4|5|7|8][0-9]{9}$/;
        if(pattern.test(value)){
            callback();
        }else{
            return callback(new Error('联系电话格式不正确'));
        }
    }
}

export default {
    components:{
        Editor
    },
    data(){
        return{

            pageH:'',
            pathurl:'',
            sort:0,
            selectArr:[],
            selectMap:{},

            params:{
                id:'',
                productServiceCategory:'',
                productServiceCategoryId:'',
                businessNewsType:'',
                businessNewsTypeId:'',
                publishCompany:'',
                publishCompanyId:'',
                title:'',
                content:'',
                coverImage:'',
                tagNames:'',
                contactPerson:'',   // 联系人
                contactPhone:'',    // 联系电话
                publisher:'',   // 发布企业
                status:3,
            },

            preCode:'',
            pgName:'',

            rules:{
                productServiceCategoryId:[{
                      required: true,
                      message:'分类必须选择',
                      trigger: 'change'
                }],
                title:[{
                      required: true,
                      message:'标题必须填写',
                      trigger: 'blur'
                }],
                contactPerson:[{
                      required: true,
                      message:'联系人必须填写',
                      trigger: 'blur'
                }],
                contactPhone:[{
                      validator: isPhone,
                      trigger: 'blur'
                }]
            }

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        contentChange:function(e){    // 富文本内容
            console.log('contentChange',e);
            this.params.content = e;
        },

        selectChange:function(e){
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
        },

        goCreate:function(status){  // 创建
            var vues = this;
            msgCreate({businessNews:this.params}).then(res => {
                if(vues.sort == 2){
                    vues.$router.push('prd_message');
                }else if(vues.sort == 3){
                    vues.$router.push('svc_message');
                }

            }).catch(err => {})
        },

        tmSave:function(){
            var vues = this;
            this.waitSave = setInterval(function(){
                var nowCode = JSON.stringify(vues.params);
                if(nowCode !== vues.preCode){
                    vues.goCreate(2);
                    vues.preCode = nowCode;
                }
            },60000)
        },

        directSave:function(){
            var vues = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    if(!vues.params.coverImage){
                        vues.$message.error('请上传封面图!');
                    }else if(!vues.params.content){
                        let arr = ['产品','服务'];
                        vues.$message.error(arr[vues.sort - 2] + '介绍必须填写!');
                    }else{
                        vues.goCreate(status);
                    }
                }
                // vues.goCreate();
            })
        },

        imgChange:function(e){
            if(e.length > 0){
               this.params.coverImage = JSON.stringify(e);
            }else{
               this.params.coverImage = '';
            }
        },

        // 标签
        tagChange:function(e){
            this.params[e.paramsKey] = e.id;
        },

        eprSeek:function(e){   // 公司检索
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              getEnterpriseList({
                 statusList:[1,2,4],
                 keyword:key,
                 sort:2,
                 no:1,
                 size:12
              }).then(res => {
                 vues.selectArr = res.enterpriseList;
                 vues.selectArr.forEach(item => {
                   vues.selectMap[item.id] = item;
                 })
              })
            }
        },

        eprSelect:function(e){
            this.params.publishCompany = this.selectMap[e].companyName;
            this.params.publishCompanyId = e;
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            this.params.businessNewsTypeId = querys.typeid;
            this.sort = querys.sort;

            // 底部定位
            this.pageFix();

            if(querys && querys.id){
                this.params.id = querys.id;
                msgPredat({id:querys.id}).then(res => {
                    vues.params = res.businessNews;
                    vues.eprSeek(vues.params.publishCompany);
                })
            }else{
                this.preCode = JSON.stringify(this.params);
                // this.tmSave();
            }

        },
    },
    created:function(){
        var vues = this;

        $(window).resize(function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

        this.prevSet();


    },

    beforeDestroy:function(){
        clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 80px;
          padding-top: 8px;
          float: left;
          .dot{
              color: salmon;
              display: inline-block;
              vertical-align: middle;
              margin-top: 3px;
          }
     }
     .bContent{
          margin-left: 90px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }
     }
}

.radio-block .el-radio-group{
     margin-top: 12px;
}

.tag-block{
   margin-top:20px;
   .bName{
        padding-top: 5px;
   }
}


</style>

<style lang="css">

.prdEdit .el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// prdEdit.vue?2b767619